/* eslint-disable react-hooks/exhaustive-deps */
/**
 * ShareProvider
 */
import _ from 'lodash'
import { numericFormatter } from 'react-number-format'
import {
  useCurrencies,
} from '../../vendor/react-omnitech-api'

export default function useCurrenciesHook() {
  const { currencies, ...others } = useCurrencies()

  const getCurrency = (code, fallback) => (
    _.find(currencies, { code })
    || fallback
    || _.find(currencies, { isBaseCurrency: true })
  )

  const formatCurrency = (value, {
    code,
    ...rest
  } = {}) => {
    const currency = getCurrency(code)
    const symbol = _.get(currency, 'formatData.disambiguateSymbol') || _.get(currency, 'formatData.symbol')
    const formatProps = {
      thousandSeparator: _.get(currency, 'formatData.thousandsSeparator'),
      decimalSeparator: _.get(currency, 'formatData.decimalMark'),
      decimalScale: _.get(currency, 'formatData.decimalPlaces'),
      fixedDecimalScale: true,
      allowNegative: true,
      prefix: _.get(currency, 'formatData.symbolFirst') ? symbol : '',
      suffix: _.get(currency, 'formatData.symbolFirst') ? '' : symbol,
      valueIsNumericString: true,
      // displayType: 'text',
      ...rest,
    }
    return numericFormatter(_.toString(value), formatProps)
  }

  return {
    currencies,
    formatCurrency,
    getCurrency,
    ...others,
  }
}
